/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticateCustomerModel
 */
export interface AuthenticateCustomerModel {
    /**
     * 
     * @type {string}
     * @memberof AuthenticateCustomerModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticateCustomerModel
     */
    accessCode: string;
}

/**
 * Check if a given object implements the AuthenticateCustomerModel interface.
 */
export function instanceOfAuthenticateCustomerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "accessCode" in value;

    return isInstance;
}

export function AuthenticateCustomerModelFromJSON(json: any): AuthenticateCustomerModel {
    return AuthenticateCustomerModelFromJSONTyped(json, false);
}

export function AuthenticateCustomerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticateCustomerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'accessCode': json['accessCode'],
    };
}

export function AuthenticateCustomerModelToJSON(value?: AuthenticateCustomerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'accessCode': value.accessCode,
    };
}

